<template>
  <div class="youtube__cont container">
    <ul>
      <li v-for="(youtube, index) in youtubes" :key="index">
        <img
          :src="youtube.snippet.thumbnails.medium.url"
          :alt="youtube.snippet.title"
        />
        <span>{{ youtube.snippet.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    youtubes: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
// youtube__wrap
.youtube__wrap {
}
.youtube__inner {
  height: 600px;
  h3 {
    font-size: 50px;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 30px;
    font-size: 22px;
  }
  a {
    @include button(#ecaa52, #e7f1ee);
    border-radius: 30px;
  }
  .youtube__item {
    position: absolute;
    margin-top: 70px;
    display: flex;
    justify-content: space-between;

    > div {
      width: 400px;
      margin-right: 20px;

      img {
        width: 100%;
      }
    }
  }
}
// youtubepage
#youtuPage {
  .cont__title {
    h2 {
      color: #49a85e;
    }
  }
}
.youtube__slider {
  display: none;
}
.youtube__search {
  text-align: center;
  margin-bottom: 50px;
  input {
    border: 1px solid #e8ecf2;
    font-size: 16px;
    padding: 10px 20px;
    min-width: 300px;
    margin-right: 10px;
    border-radius: 50%;
  }
  button {
    border-radius: 50%;
  }
}
.youtube__tag {
  ul {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    li {
      a {
        border: 1px solid #b6ccee;
        padding: 10px 20px;
        margin: 10px;
        color: #b6ccee;
        span {
          display: block;
          margin: 4px 0;
        }
      }
    }
  }
}
.youtube__cont {
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 100px;

    li {
      width: 24.333%;
      margin-bottom: 4%;

      span {
        display: block;
        margin: 10px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1; /* 라인수 */
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
      img {
        width: 100%;
        transition: all 0.3s;
        border-radius: 5px;

        &:hover {
          transform: scale(110%);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
